<div>
    <h2>{{'usuarios.etiquetador.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'usuarios.etiquetador.filters.denominacion' | translate}}</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')" [disabled]="disabledDenominacion" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'usuarios.etiquetador.filters.etiquetador' | translate}}</label>
                <input type="text" formControlName="des">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'usuarios.etiquetador.filters.userName' | translate}}</label>
                <input type="text" formControlName="userName">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="alignment-start-filters">
              <checkbox [id]="'habilitado'" [initialStatus]="''" [initialRefresh]="refreshCheckbox_habilitado" [label]="'usuarios.etiquetador.filters.habilitado'" (refresh)="this.refreshCheckbox_habilitado = false" (formValue)="this.filtersForm.get('habilitado').patchValue($event)" (pristine)="pristineCheckbox('habilitado', $event)"></checkbox>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
          title="{{'global.filtros.abrir' | translate}}">
          <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
          (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
          <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
          [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
          title="{{'global.filtros.limpiar' | translate}}">
          <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
          title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
          <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <div class="table-wrapper">
      <div class="table-container">
        <table>
          <thead>
              <tr>
                  <th class="multi-icon"></th>
                  <!-- <th class="string">{{'usuarios.etiquetador.table.id' | translate}}</th> -->
                  <th class="string sortable" (click)="toOrderBy('x=> x.ApplicationUser.Nombre', 2)">
                    {{'usuarios.etiquetador.table.nombre' | translate}}
                    <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.ApplicationUser.Nombre')"></i></div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.ApplicationUser.Apellido', 3)">
                    {{'usuarios.etiquetador.table.apellido' | translate}}
                    <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.ApplicationUser.Apellido')"></i></div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.Etiquetador.Des', 4)">
                    {{'usuarios.etiquetador.table.etiquetador' | translate}}
                    <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.Etiquetador.Des')"></i></div>
                  </th>
                  <th class="string-long sortable" (click)="toOrderBy('x=> x.ApplicationUser.UserName', 5)">
                    {{'usuarios.etiquetador.table.username' | translate}}
                    <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.ApplicationUser.UserName')"></i></div>
                  </th>
                  <th class="date sortable" (click)="toOrderBy('x=> x.fechaIns', 6)">
                    {{'global.fecha.insercionShort' | translate}}
                    <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaIns')"></i></div>
                  </th>
                  <th class="date">{{'global.fecha.actualizacionShort' | translate}}</th>
                  <th class="multi-actions-bigSubtable">
                      <i class="fas fa-plus" *ngIf="this.role === 'Administrador'" (click)="create()"  title="{{'usuarios.etiquetador.tituloNew' | translate}}"></i>
                      <i class="fa-solid fa-address-card" title="{{'titles.enviarInvitacion' | translate}}"
                          *ngIf="this.claims && this.claims.includes('D_EQS_SendInv')" (click)="sendInvitation()"></i>
                  </th>
              </tr>
          </thead>
          <tbody *ngFor="let etiquetador of etiquetadoresList; trackBy: trackByUserName">
              <tr>
                  <td class="multi-icon">
                      <i class="fas fa-sm fa-user-lock" *ngIf="!etiquetador.activo" title="{{'titles.usuarioDesactivado' | translate}}"></i>
                  </td>
                  <!-- <td class="string">{{etiquetador.applicationUserId}}</td> -->
                  <td class="string-overflow" title="{{etiquetador.nombre ? etiquetador.nombre : 'NO INDICADO'}}">{{etiquetador.nombre ? etiquetador.nombre : 'NO INDICADO'}}</td>
                  <td class="string">{{etiquetador.apellido ? etiquetador.apellido : 'NO INDICADO'}}</td>
                  <td class="string">{{etiquetador.desEtiquetador}}</td>
                  <td class="string-long">{{etiquetador.userName}}</td>
                  <td class="date">{{etiquetador.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                  <td class="date">{{etiquetador.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
                  <td class="multi-actions-bigSubtable">
                      <i [ngClass]="etiquetador.activo ? 'fa-solid fa-lock-open': 'fa-solid fa-lock'" *ngIf="(this.role === 'Administrador' || (this.claims && this.claims.includes('ETQ_USER_Upd')))"
                          app-click-stop-propagation (click)="block(etiquetador)"
                          title="{{etiquetador.activo ? ('titles.usuarioActivado' | translate) : ('titles.usuarioDesactivado' | translate)}}"></i>
                      <i class="fas fa-pencil-alt" *ngIf="(this.role === 'Administrador' || (this.claims && this.claims.includes('ETQ_USER_Upd')))"
                          [ngClass]="{'disabled': (!etiquetador.registroEditable)}" app-click-stop-propagation (click)="update(etiquetador)"
                          title="{{'titles.editar' | translate}}"></i>
                      <i class="far fa-trash-alt" *ngIf="this.role === 'Administrador'" [ngClass]="{'disabled': (etiquetador.registroEnUso)}"
                          app-click-stop-propagation title="{{'titles.eliminar' | translate}}" (click)="askDelete(etiquetador)"
                          title="{{'titles.eliminar' | translate}}"></i>
                  </td>
              </tr>
          </tbody>
          <tfoot *ngIf="!etiquetadoresList || (etiquetadoresList && etiquetadoresList.length < 1)">
              <tr>
                  <td colspan="8">
                      {{'global.noContent' | translate}}
                  </td>
              </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <app-paginator *ngIf="etiquetadoresList && etiquetadoresList.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
        [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event;showWarning=$event"></app-toast>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{etiquetadorId ? ('usuarios.etiquetador.tituloEdit' | translate) : ('usuarios.etiquetador.tituloNew' | translate)}}</h4>
        </header>
        <app-eqs-new-edit [etiquetadorId]="etiquetadorId" [applicationUserId]="applicationUserId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)"></app-eqs-new-edit>
    </div>
</div>
<div class="modal" *ngIf="sendInvitationModal">
    <div class="modal-content">
      <header>
        <h4>{{ 'global.enviarInvitacion' | translate }}</h4>
      </header>
      <app-send-invitation (refresh)="refresh($event)" (mensaje)="pushMessage($event)"></app-send-invitation>
    </div>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
      </header>
      <content>
        <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
      </content>
      <footer>
        <button class="secondary" (click)="close()">{{ 'global.cancelar' | translate }}</button>
        <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
      </footer>
    </div>
</div>
